import api from './api';

export const getUsers = async (params) => {
  const response = await api.get('/auth/user', { params });
  return response.data;
};

export const getUser = async (id) => {
  const response = await api.get(`/auth/user/${id}`);
  return response.data;
};

export const createUser = async (data) => {
  const response = await api.post('/auth/user', data);
  return response.data;
};

export const updateUser = async (data) => {
  const response = await api.put('/auth/user', data);
  return response.data;
};

export const deleteUser = async (id) => {
  const response = await api.delete(`/auth/user/${id}`);
  return response.data;
};
